import { useNavigate } from 'react-router-dom'

import { ProjectsTotalCountDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useOnboarding } from 'modules/project_management/contexts/onboardingContext'

const ProjectsDefaultPage = () => {
  const onboardingContext = useOnboarding()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const showOnboarding = onboardingContext?.showOnboarding.current
  const { data, loading } = useQuery(ProjectsTotalCountDocument, {
    skip: !showOnboarding,
  })

  const hasProjects = !!data?.projectManagement.projectsConnection.totalCount

  const getRedirectUrl = () => {
    if (showOnboarding && !hasProjects) {
      return navigation.projects.onboarding.fullPath()
    } else {
      onboardingContext?.setShowOnboarding(false)
      return navigation.projects.list.fullPath()
    }
  }

  useEffect(() => {
    if (!loading) {
      navigate(getRedirectUrl(), { replace: true })
    }
  }, [loading])

  return <></>
}

export default ProjectsDefaultPage
